import AdminEleven from "@/layouts/AdminEleven.vue";

export const financesRoutes = [
  {
    path: "/financeiro",
    component: AdminEleven,
    props: {
      withSearchInput: false,
    },
    children: [
      {
        name: "regional",
        path: "/regionais",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/finance/Regionals.vue"
          ),
        meta: {
          title: "Regionais",
          requiresAuth: true,
          requiresAdminProfile: true,
        },
      },
      {
        name: "financePaymentMethods",
        path: "/formas-pagamento",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/finance/PaymentMethods.vue"
          ),
        meta: {
          title: "Formas de Pagamento",
          requiresAuth: true,
          requiresAdminProfile: true,
        },
      },
    ],
  },
];
